/*
 * This illustrates how to create a widget that makes use of a number of different field definition types.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TokenExFrame from "@insite/mobius/TokenExFrame/TokenExFrame";
import { generateTokenExFrameStyleConfig } from "@insite/mobius/TokenExFrame/TokenExFrameStyleConfig";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

// this is used to help ensure that the names match between props.fields and definition.fieldDefinitions[].name
const enum fields {
    textFieldValue = "textFieldValue",
    textFieldValue1 = "textFieldValue1",
}

interface Props extends WidgetProps {
    fields: {
        [fields.textFieldValue]: string;
        [fields.textFieldValue1]: string;
    };
}
export interface LinkYouTubeVideoWidgetStyles {
    container?: InjectableCss;
}

const LinkYouTubeVideoWidgetStyles: LinkYouTubeVideoWidgetStyles = {
    container: {
        css: css`
            font-size: 28px;
            font-weight: 600;
            border-bottom: 2px solid #005cb9;
            color: #005cb9;
            display: inline-block;
            margin: 0 0 10px;
            padding-bottom: 5px;
            text-transform: uppercase;
            line-height: 26px;
            text-align: center;
            width: 100%;
            iframe {
                height: 260px;
                width: 100%;
            }
        `,
    },
};

const LinkYouTubeVideoWidget: React.FC<Props> = props => {
    const TheIframe = <iframe src={props.fields.textFieldValue} style={{ border: 0 }} width="100%" height="100%" />;
    return (
        <StyledWrapper {...LinkYouTubeVideoWidgetStyles.container}>
            <StyledWrapper {...LinkYouTubeVideoWidgetStyles.container}>{props.fields.textFieldValue1}</StyledWrapper>
            <TokenExFrame tokenExIFrameContainer={TheIframe} />
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Testing",
    fieldDefinitions: [
        {
            name: fields.textFieldValue,
            displayName: "Text",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "text placeholder",
            isRequired: true,
        },
        {
            name: fields.textFieldValue1,
            displayName: "Heading",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "text placeholder",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: LinkYouTubeVideoWidget,
    definition,
};

export default widgetModule;
